import { useNavigate } from 'react-router-dom';
import ReactDom from 'react-dom';
import SampleQuantumJobButton from './SampleQuantumJobButton';
import SampleSimulatedJobButton from './SampleSimulatedJobButton';

const QuantumButtons = () => {
  const navigate = useNavigate();

  const sampleJobButtonContainer = document.getElementById('magicButtonA_plus_B');
  const sampleQuantumJobButtonContainer = document.getElementById('magicButtonQuantum');

  return (
    <div>
      {sampleQuantumJobButtonContainer && ReactDom.createPortal(
        <SampleQuantumJobButton redirect={navigate} />,
        sampleQuantumJobButtonContainer,
      )}
      {sampleJobButtonContainer && ReactDom.createPortal(
        <SampleSimulatedJobButton redirect={navigate} />,
        sampleJobButtonContainer,
      )}
    </div>
  );
};

export default QuantumButtons;
